import { render } from "./JobItem.vue?vue&type=template&id=b45b5266&scoped=true&ts=true"
import script from "./JobItem.vue?vue&type=script&lang=ts"
export * from "./JobItem.vue?vue&type=script&lang=ts"

import "./JobItem.vue?vue&type=style&index=0&id=b45b5266&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45b5266"]])

export default __exports__